import { AuthService } from 'addiction-auth';
import { showSugarAuthError, SugarAuthService } from './sugar-auth.service';

export const authServiceInit = (authService: AuthService, sugarAuth: SugarAuthService) => {
  // init operazioni preliminari
  return async () => {
    if (sugarAuth.isSugarIframe) {
      try {
        // Dentro l'iframe Sugar: scambio token invece del redirect Keycloak.
        await sugarAuth.authenticate();
        // Token già seminati: runInitialLoginSequence non fa né refresh né redirect, ribalta solo
        // isDoneLoading$/isAuthenticated$ così che guard e app vedano l'utente loggato.
        await authService.runInitialLoginSequence(true);
      } catch (e) {
        console.error('Autenticazione SugarCRM fallita', e);
        // Nessun fallback possibile a Keycloak dentro l'iframe (CSP): mostra un errore con retry.
        showSugarAuthError();
      }
      return;
    }
    if (!location.href.includes('/registration')) {
      try {
        await authService.runInitialLoginSequence();
        return;
      } catch (e) {
        console.error(e);
      }
    }
  };
};
